"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _models = require("@nopanoga/models");

var _Text = require("../Text");

var _BottomButton = require("../Button/BottomButton");

var _Header = _interopRequireDefault(require("./Header"));

var _Video = _interopRequireDefault(require("./Video"));

var _BgGriffe = _interopRequireDefault(require("./BgGriffe"));

var _Infos = _interopRequireDefault(require("./Infos"));

var _Description = _interopRequireDefault(require("./Description"));

var _Equipements = _interopRequireDefault(require("./Equipements"));

var _ExerciceList = _interopRequireDefault(require("./ExerciceList"));

var _SessionPreview = _interopRequireDefault(require("./SessionPreview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = _reactNative.StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    backgroundColor: '#000000'
  },
  scrollView: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  view: {
    height: 2000
  },
  videoContainer: {
    marginTop: 30,
    width: '100%',
    alignItems: 'center'
  }
});

var Container = function Container(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, children);
};

var _default = function _default(_ref2) {
  var trainingSession = _ref2.trainingSession;
  var animatedValue = new _reactNative.Animated.Value(0);
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_BgGriffe["default"], {
    animatedValue: animatedValue
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.Animated.ScrollView, {
    scrollEventThrottle: 16,
    style: styles.scrollView,
    stickyHeaderIndices: [0],
    showsVerticalScrollIndicator: false,
    onScroll: _reactNative.Animated.event([{
      nativeEvent: {
        contentOffset: {
          y: animatedValue
        }
      }
    }])
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    animatedValue: animatedValue,
    trainingSession: trainingSession
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.videoContainer
  }, /*#__PURE__*/_react["default"].createElement(_Video["default"], {
    trainingSession: trainingSession
  })), /*#__PURE__*/_react["default"].createElement(_Infos["default"], {
    trainingSession: trainingSession,
    style: {
      marginTop: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(_Description["default"], {
    trainingSession: trainingSession,
    style: {
      marginTop: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(_Equipements["default"], {
    trainingSession: trainingSession,
    style: {
      marginTop: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(_ExerciceList["default"], {
    trainingSession: trainingSession,
    style: {
      marginTop: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(_SessionPreview["default"], {
    trainingSession: trainingSession,
    style: {
      marginTop: 10,
      marginBottom: 20
    }
  })));
};

exports["default"] = _default;